let base = window._env_.VUE_APP_RECRUIT_HOST
export const getResumeTable = params => {
  return axios.post(`${base}/applied_resume_` + params.position_id, params)
}
export const getResumeForm = id => {
  return axios.get(`${base}/resume_` + id)
}
export const exportResume = params => {
  return axios.post(`${base}/export_resume_` + params.position_id, params)
}
export const exportResumes = params => {
  return axios.post(`${base}/export_resume`, params)
}

export const appliedResume = params => {
  return axios.post(`${base}/applied_${params.positionId}_resume_${params.id}`, params)
}
export const sendResumes = params => {
  return axios.post(`${base}/send_resumes`, params)
}
export const downloadResume = path => {
  window.location.href = `${base}/download_resume_` + path
}
export const getResumeOptions = params => {
  return axios.get(`${base}/resume_options`)
}
export const getResumeAllTable = params => {
  return axios.get(`${base}/query_resumes`, {params})
}
export const getResumeCity = params => {
  return axios.post(`${base}/query_resumes_city`)
}
export const editResume = params => {
  return axios.post(`${base}/edit_resume_${params.id}`, params)
}
export const uploadResumeImg = params => {
  return axios.post(`${base}/upload_avatar`, params)
}
export const queryCity = params => {
  return axios.post(`${base}/query_city`, params)
}



// WEBPACK FOOTER //
// ./src/views/resume/resume.api.js